import { Animation } from '@kcd/design-system';
import LoadingDotAnimationData from '@kcd/design-system/dist/assets/animations/loading-dot.json';
import { useEffect, useState } from 'react';

import { useEstimateProductPayment } from '~/api/domains/products';
import type { EstimateProductPayment } from '~/api/model';

import { TotalAmountDetail } from './TotalAmountDetail';
import type { ProductOption } from './types';

type Props = {
  offerId: number;
  selectedProductOptions: ProductOption[];
};

export function TotalAmountContainer({
  offerId,
  selectedProductOptions,
}: Props) {
  const { mutateAsync: estimateProductPayment } = useEstimateProductPayment();

  const [data, setData] = useState<EstimateProductPayment>();

  useEffect(() => {
    void (async () => {
      if (selectedProductOptions.length === 0) return;
      const options = selectedProductOptions.map((option) => ({
        offerId: option.offerId,
        skuId: option.skuId!,
        quantity: option.count,
      }));

      const requestBody = {
        offerId,
        options,
      };

      if (offerId !== requestBody.options[0].offerId) {
        // 상품과 옵션이 매칭되지 않으면 API 미요청
        return;
      }

      const result = await estimateProductPayment(requestBody);
      setData(result);
    })();
  }, [estimateProductPayment, offerId, selectedProductOptions]);

  if (!data || !selectedProductOptions.length)
    return (
      <div className="flex justify-center items-center h-80">
        <Animation loop speed={2} size={64} data={LoadingDotAnimationData} />
      </div>
    );

  return <TotalAmountDetail data={data} />;
}
